import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NavigationExtras, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { INIT_REQUEST_HEADER } from '../services/user-init.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private location: Location,
    private router: Router,
    private matDialog: MatDialog
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isInitRequest = req.headers.has(INIT_REQUEST_HEADER);

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error(err);

        if (err.status === 404 || err.status === 500 || err.status === 502 || err.status === 503 || err.status === 504) {
          const params: NavigationExtras = {
            queryParams: { code: err.status, message: err.message },
          };

          if (err.status === 404 && err.message.includes('/server-error?code=500')) {
            const url = err.url;
            if (url) {
              const search = new URL(url).search.substring(1);
              const _params = new URLSearchParams(search);
              params.queryParams!.code = _params.get('code');
              params.queryParams!.message = _params.get('message');
            }
          }

          if (isInitRequest) {
            window.location.href = '/server-error';
          } else {
            this.router.navigate(['/server-error'], params);
            this.matDialog.closeAll();
          }
        }

        if (
          err.status === 401 &&
          !this.location.path().includes('/auth/signin') &&
          !this.location.path().includes('/specialists-signin') &&
          !this.location.path().includes('/esia-token-and-scope') &&
          !this.location.path().includes('/auth/confirm') &&
          !this.location.path().includes('/email-confirm')
        ) {
          window.location.href = '/auth/signin';
          return isInitRequest ? throwError(err) : EMPTY;
        }

        if (err.status === 403 && !this.location.path().includes('/blocked')) {
          const esiaLogoutUrl = err.headers.get('X-Esia-Logout-Url');
          if (esiaLogoutUrl) {
            if (!isInitRequest) {
              this.matDialog.closeAll();
            }
            window.location.href = esiaLogoutUrl;
          } else if (isInitRequest) {
            window.location.href = '/blocked';
          } else {
            this.router.navigate(['/blocked']);
            this.matDialog.closeAll();
          }
          return isInitRequest ? throwError(err) : EMPTY;
        }

        if (err.status === 406 && !this.location.path().includes('/session-expired')) {
          if (isInitRequest) {
            window.location.href = '/session-expired';
          } else {
            this.router.navigate(['/session-expired'], { queryParamsHandling: 'merge' });
            this.matDialog.closeAll();
          }
          return isInitRequest ? throwError(err) : EMPTY;
        }

        return throwError(err);
      })
    );
  }
}
